import type {Choice} from '../types/session'

/**
 * When a choice has BOTH reasoning_text AND tool_calls, split it into two separate choices:
 * 1. First choice: reasoning_text only (no tool_calls, no content) - renders outside groups
 * 2. Second choice: tool_calls and content (no reasoning_text) - can be grouped with other tools
 *
 * This ensures reasoning_text renders before tool groups rather than inside them.
 */
export function splitChoiceWithReasoningText(choice: Choice): Choice[] {
  const hasReasoningText = !!choice.delta.reasoning_text
  const hasToolCalls = !!(choice.delta.tool_calls && choice.delta.tool_calls.length > 0)

  if (hasReasoningText && hasToolCalls) {
    return [
      // First: reasoning_text only (won't be grouped since no tool_calls)
      {
        ...choice,
        delta: {
          ...choice.delta,
          tool_calls: undefined,
          content: undefined,
        },
      },
      // Second: tool_calls only (will be grouped normally)
      {
        ...choice,
        delta: {
          ...choice.delta,
          reasoning_text: undefined,
        },
      },
    ]
  }

  return [choice]
}

/**
 * Determines whether a choice should be split based on having both reasoning_text and tool_calls.
 */
export function shouldSplitChoice(choice: Choice): boolean {
  const hasReasoningText = !!choice.delta.reasoning_text
  const hasToolCalls = !!(choice.delta.tool_calls && choice.delta.tool_calls.length > 0)
  return hasReasoningText && hasToolCalls
}
